import React, { useState, useEffect } from 'react';
import HeaderComponent from '../../Shared/components/HeaderComponent';
import ListadoPerfilLayout from './ListadoPerfilLayout';
import ModalFormPerfil from '../modals/ModalFormPerfil';
import useCustomNavigate from '../../../hooks/useCustomNavigate';
import { PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Layout, Button } from 'antd';
const { Content } = Layout;

const PerfilLayout = () => {

    const navigate = useCustomNavigate();
    const [openDialogProfile, setDialogProfile] = useState(false);
    const [action, setAction] = useState("create");
    const [profileData, setProfileData] = useState();

    {/** FUNCTIONS MODAL FORM PROFILE **/ }
    const cancelDialogProfile = () => {
        setProfileData();
        setAction("create");
        setDialogProfile(false);
    }
    const realodData = () => {
        setProfileData();
        setAction("create");
        return true
    };
    const EditProfile = (idProfile) => {
        setProfileData(idProfile);
        setAction("update");
        setDialogProfile(true);
    }

    return (
        <Layout>
            <Content>
                <Breadcrumb
                    className='breadcrumb'
                    items={[
                        { title: <a href="/home">Inicio</a> },
                        { title: "Perfiles" }
                    ]}
                />
                <HeaderComponent title="Perfiles" />
                <div className='w-full flex flex-end'>
                    <Button type="primary" shape="round"
                        className='mb-15'
                        onClick={() => setDialogProfile(true)}
                    >
                        <PlusOutlined /> Nuevo perfil
                    </Button>
                </div>

                <ListadoPerfilLayout
                    realodData={realodData}
                    EditProfile={EditProfile}
                >
                </ListadoPerfilLayout>

            </Content>

            {/** INIT MODAL FORM PROFILE **/}
            <ModalFormPerfil
                action={action}
                profileData={profileData}
                openDialogProfile={openDialogProfile}
                cancelDialogProfile={cancelDialogProfile}
                realodData={realodData}
            />
            {/** END MODAL FORM PROFILE **/}
        </Layout>
    )
}

export default PerfilLayout;